export default __webpack_public_path__ + "static/media/instagram.63a7e8f6.svg";